import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

application = Application.start()
context = require.context("controllers", true, /_controller\.coffee$/)
application.load(definitionsFromContext(context))
